/**
 * @generated SignedSource<<6198b180a29a02a9c0c26c3661b386b7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type SearchLinkedResultCategory = "mentionedBy" | "mentions" | "similar" | "%future added value";
export type SearchResultType = "ask" | "attachment" | "blogpost" | "board" | "comment" | "component" | "dashboard" | "database" | "document" | "embed" | "filter" | "focus_area" | "focus_area_status_update" | "folder" | "goal" | "goal_update" | "issue" | "learning" | "message" | "object" | "page" | "plan" | "position" | "presentation" | "project" | "project_update" | "question" | "repository" | "schema" | "space" | "spreadsheet" | "tag" | "type" | "unrecognised" | "whiteboard" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type searchGraphRepository_AtlassianSearchPage$data = {
  readonly __typename: "SearchResultGraphDocument";
  readonly excerpt: string | null | undefined;
  readonly id: string;
  readonly lastModifiedDate: string | null | undefined;
  readonly linkedResults: ReadonlyArray<{
    readonly category: SearchLinkedResultCategory;
    readonly connectorType: string | null | undefined;
    readonly description: string;
    readonly id: string;
    readonly integrationId: string | null | undefined;
    readonly lastModifiedDate: string | null | undefined;
    readonly providerId: string | null | undefined;
    readonly subtype: string | null | undefined;
    readonly title: string;
    readonly type: SearchResultType;
    readonly url: string;
  }> | null | undefined;
  readonly permissionLevel: string | null | undefined;
  readonly title: string;
  readonly url: string;
  readonly " $fragmentType": "searchGraphRepository_AtlassianSearchPage";
};
export type searchGraphRepository_AtlassianSearchPage$key = {
  readonly " $data"?: searchGraphRepository_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchGraphRepository_AtlassianSearchPage">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "lastModifiedDate"
},
v2 = {
  "kind": "ScalarField",
  "name": "url"
},
v3 = {
  "kind": "ScalarField",
  "name": "title"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "searchGraphRepository_AtlassianSearchPage",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    {
      "kind": "ScalarField",
      "name": "permissionLevel"
    },
    (v3/*: any*/),
    {
      "kind": "ScalarField",
      "name": "excerpt"
    },
    {
      "concreteType": "SearchLinkedResult",
      "kind": "LinkedField",
      "name": "linkedResults",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v3/*: any*/),
        (v2/*: any*/),
        {
          "kind": "ScalarField",
          "name": "type"
        },
        {
          "kind": "ScalarField",
          "name": "description"
        },
        (v1/*: any*/),
        {
          "kind": "ScalarField",
          "name": "category"
        },
        {
          "kind": "ScalarField",
          "name": "subtype"
        },
        {
          "kind": "ScalarField",
          "name": "integrationId"
        },
        {
          "kind": "ScalarField",
          "name": "providerId"
        },
        {
          "kind": "ScalarField",
          "name": "connectorType"
        }
      ]
    }
  ],
  "type": "SearchResultGraphDocument"
};
})();

(node as any).hash = "ca41a20e0191caf0691caf5ec12937f3";

export default node;
